// DO NOT EDIT -- generated from fs/services/search-settings/heatmaps.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as visualizationsettings from './visualizationsettings';

export namespace Heatmaps {

  export const GetAllHeatmapsEndpoint = "/grpc/search_settings.Heatmaps/GetAllHeatmaps";
  /**
   * Get all current non-archived heatmaps for an org.
   * If desired, archived heatmaps can also be retrieved with the explicit request flag.
   */
  export function GetAllHeatmaps(sender: (req: GetAllHeatmapsRequest, endpoint: string) => Promise<GetAllHeatmapsResponse>, req: GetAllHeatmapsRequest): { promise: () => Promise<GetAllHeatmapsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllHeatmapsEndpoint),
      endpoint: GetAllHeatmapsEndpoint
    };
  }

  export const GetHeatmapEndpoint = "/grpc/search_settings.Heatmaps/GetHeatmap";
  /** Get a specific heatmap, either current or past version. */
  export function GetHeatmap(sender: (req: GetHeatmapRequest, endpoint: string) => Promise<GetHeatmapResponse>, req: GetHeatmapRequest): { promise: () => Promise<GetHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHeatmapEndpoint),
      endpoint: GetHeatmapEndpoint
    };
  }

  export const SetHeatmapEndpoint = "/grpc/search_settings.Heatmaps/SetHeatmap";
  /** Add a new heatmap or update an existing heatmap. */
  export function SetHeatmap(sender: (req: SetHeatmapRequest, endpoint: string) => Promise<SetHeatmapResponse>, req: SetHeatmapRequest): { promise: () => Promise<SetHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetHeatmapEndpoint),
      endpoint: SetHeatmapEndpoint
    };
  }

  export const ArchiveHeatmapEndpoint = "/grpc/search_settings.Heatmaps/ArchiveHeatmap";
  /**
   * Archive an existing heatmap for an org.
   * Once archived, the heatmap cannot be modified and will not show up in GetAllHeatmaps unless explicitly requested.
   */
  export function ArchiveHeatmap(sender: (req: ArchiveHeatmapRequest, endpoint: string) => Promise<ArchiveHeatmapResponse>, req: ArchiveHeatmapRequest): { promise: () => Promise<ArchiveHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveHeatmapEndpoint),
      endpoint: ArchiveHeatmapEndpoint
    };
  }

  export const UnarchiveHeatmapEndpoint = "/grpc/search_settings.Heatmaps/UnarchiveHeatmap";
  /**
   * Unarchives an existing heatmap for an org.
   * Once unarchived, the heatmap can continue to be modified and will show up in GetAllHeatmaps.
   */
  export function UnarchiveHeatmap(sender: (req: UnarchiveHeatmapRequest, endpoint: string) => Promise<UnarchiveHeatmapResponse>, req: UnarchiveHeatmapRequest): { promise: () => Promise<UnarchiveHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveHeatmapEndpoint),
      endpoint: UnarchiveHeatmapEndpoint
    };
  }

  export const GetHeatmapsAccessEndpoint = "/grpc/search_settings.Heatmaps/GetHeatmapsAccess";
  export function GetHeatmapsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHeatmapsAccessEndpoint),
      endpoint: GetHeatmapsAccessEndpoint
    };
  }
}

export interface GetAllHeatmapsRequest {
  orgId: string;
  /** If true, archived heatmaps will also be returned. */
  includeArchived: boolean;
  /** By default, only public heatmaps are returned */
  includePrivate: boolean;
}

export interface GetAllHeatmapsResponse {
  heatmaps: HeatmapRecord[];
}

export interface GetHeatmapRequest {
  /** required */
  orgId: string;
  /** required */
  heatmapId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetHeatmapResponse {
  versions: HeatmapRecord[];
}

export interface SetHeatmapRequest {
  orgId: string;
  /**
   * Heatmap to be created or updated.
   * If the id field is not set, an id will be generated and a new heatmap will be stored.
   */
  heatmap: Heatmap | null;
  visibility: protoauditstore.Visibility;
}

export interface SetHeatmapResponse {
  heatmap: HeatmapRecord | null;
}

export interface ArchiveHeatmapRequest {
  orgId: string;
  heatmapId: string;
}

export interface ArchiveHeatmapResponse {
  heatmap: HeatmapRecord | null;
}

export interface UnarchiveHeatmapRequest {
  orgId: string;
  heatmapId: string;
}

export interface UnarchiveHeatmapResponse {
  heatmap: HeatmapRecord | null;
}

export interface Heatmap {
  id: string;
  name: string;
  description: string;
  /**
   * HeatmapEvent specifies the Visited Page Event (with the selected PageDefId) and any dependent filters (ie. PageVars)
   * This criteria is used to look up the session and representative Page to present the Heatmap visualization.
   */
  heatmapEvent: segment.Event | null;
  /** RepresentativePage contains the parameters last used to present the Heatmap visualization */
  representativePage: RepresentativePage | null;
  /** Additional viz settings (ie. Segment, TimeRange, Device) */
  heatmapSettings: visualizationsettings.HeatmapSettings | null;
}

export interface RepresentativePage {
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  pageId: protobuf.int64;
  pageStartAt: protobuf.timestamp | null;
  pageDefLastUpdatedAt: protobuf.timestamp | null;
  /** If true, page_start_at is treated as an absolute timestamp used to present the Heatmap visualization */
  timestampPredetermined: boolean;
}

export interface HeatmapRecord {
  heatmap: Heatmap | null;
  metadata: protoauditstore.AuditMetadata | null;
}
